const VERSION = "v1";
export const urlConstructor = (endpoint) => {
  return `${process.env.REACT_APP_API_URL}/${VERSION}/${endpoint}`;
};

export const END_POINTS = {
  ADMIN_LIST: "admin",
  SERVICE_OFFERINGS: "service-offerings",
  SERVICE_PROVIDER: "service-providers",
};

export const AUTHENTICATED = "authenticated";

export const STATUS = {
  success: "success",
  error: "error",
  info: "info",
  warning: "warning",
};
export const API_RESPONSE_OK = "Ok";

/**
 * status codes for API's
 */
export const STATUS_CODES = {
  UPDATE: 201,
  SUCCESS: 200,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  BAD_GATEWAY: 502,
  INTERNAL_ERROR: 500,
  GATEWAY_TIMEOUT: 504,
};
